/* eslint-disable */
import Vue from "vue";
import store from "@/store";

export default {
  install() {
    Vue.prototype.$permission = (permission) => {
      const permissions = store.getters['agency/permissions'];
      return permissions.includes(permission);
    };
  }
};
